module.exports = __webpack_public_path__ + "static/img/01.87512333.png";